<template>
  <div class="result-list" :class="{ 'result-list--grid': viewMode === 'grid' }">
    <article
      v-for="item in list"
      :key="item.id"
      class="result-card"
    >
      <div class="result-card__thumb">
        <img
          :src="item.image || defaultCover"
          :alt="item.title"
          :class="{ 'result-card__thumb-img--default': !item.image }"
        />
      </div>

      <div class="result-card__body">
        <h3 class="result-card__title">{{ item.title }}</h3>
        <dl class="result-card__meta">
          <div v-for="field in displayMeta(item)" :key="field.label" class="result-card__meta-row">
            <dt>{{ field.label }}：</dt>
            <dd>{{ field.value || '-' }}</dd>
          </div>
        </dl>
        <p class="result-card__intro">
          <span class="result-card__intro-label">简介：</span>{{ item.intro }}
        </p>
      </div>

      <div class="result-card__aside">
        <span class="result-card__tag" :class="`result-card__tag--${item.type}`">
          {{ item.typeLabel }}
        </span>
        <router-link
          v-if="detailRoute(item)"
          :to="detailRoute(item)"
          class="result-card__link"
        >
          查看知识 &gt;
        </router-link>
        <span v-else class="result-card__link result-card__link--disabled">查看知识 &gt;</span>
      </div>
    </article>

    <div v-if="!list.length" class="result-list__empty">
      暂无检索结果
    </div>
  </div>
</template>

<script>
import defaultCover from '@/assets/default-cover-square.png'

const DETAIL_TYPES = ['renwu', 'jigou', 'didian', 'shijian']

export default {
  name: 'KnowledgeResultList',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    viewMode: {
      type: String,
      default: 'list'
    }
  },
  data() {
    return { defaultCover }
  },
  methods: {
    displayMeta(item) {
      return item.meta || []
    },
    detailRoute(item) {
      if (!DETAIL_TYPES.includes(item.type)) return null
      return `/knowledge/${item.type}/${item.id}`
    }
  }
}
</script>

<style lang="scss" scoped>
.result-list {
  display: flex;
  flex-direction: column;
  gap: $spacing-base;
  margin-top: $spacing-base;

  &--grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));

    .result-card {
      flex-direction: column;

      &__thumb {
        width: 100%;
        height: 180px;
      }

      &__aside {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding-top: $spacing-sm;
        border-top: 1px solid rgba($color-border, 0.4);
      }
    }
  }

  &__empty {
    padding: $spacing-3xl;
    text-align: center;
    color: $color-text-light;
    background: $color-white;
    border-radius: 4px;
  }
}

.result-card {
  display: flex;
  gap: $spacing-base;
  padding: $spacing-base;
  background: $color-white;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba($color-brown-dark, 0.06);
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 4px 20px rgba($color-brown-dark, 0.1);
  }

  &__thumb {
    width: 140px;
    height: 140px;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
    background: $color-paper-light;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      filter: grayscale(0.5) sepia(0.2);

      &.result-card__thumb-img--default {
        filter: none;
      }
    }
  }

  &__body {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-family: $font-serif;
    font-size: rem(20);
    font-weight: 700;
    color: $color-brown-dark;
    margin-bottom: $spacing-sm;
  }

  &__meta {
    display: flex;
    flex-wrap: wrap;
    gap: $spacing-sm $spacing-xl;
    margin-bottom: $spacing-sm;
  }

  &__meta-row {
    display: flex;
    font-size: rem(13);

    dt {
      color: $color-text-light;
      flex-shrink: 0;
    }

    dd {
      color: $color-text;
    }
  }

  &__intro {
    font-size: rem(13);
    line-height: 1.8;
    color: $color-text-light;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__intro-label {
    color: $color-text;
    font-weight: 500;
  }

  &__aside {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    flex-shrink: 0;
    min-width: 80px;
  }

  &__tag {
    font-size: rem(12);
    padding: 2px $spacing-sm;
    border-radius: 2px;

    &--person {
      background: #fef3c7;
      color: #92400e;
    }

    &--org {
      background: #dcfce7;
      color: #15803d;
    }

    &--location {
      background: #dbeafe;
      color: #1d4ed8;
    }

    &--event {
      background: #ede9fe;
      color: #6d28d9;
    }
  }

  &__link {
    font-size: rem(13);
    color: $success-color;

    &:hover {
      text-decoration: underline;
    }

    &--disabled {
      opacity: 0.5;
      cursor: default;

      &:hover {
        text-decoration: none;
      }
    }
  }
}

@media (max-width: 768px) {
  .result-card {
    flex-direction: column;

    &__thumb {
      width: 100%;
      height: 160px;
    }

    &__aside {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
  }
}
</style>
